module.exports = __webpack_public_path__ + "static/media/mountain_mobile.1e91a003.jpg";